<script setup lang="ts">
import { onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import AuthService from "@/common/api/auth.service";
import { useLoader } from "@/common/composables/use-loader.composable";
import FocusedMessage from "@/components/FocusedMessage.vue";
import { useAuthStore } from "@/stores";

const { t } = useI18n();
const router = useRouter();
const { showLoadingWhile } = useLoader(router);

const authStore = useAuthStore();

onBeforeMount(() => {
  window.addEventListener("message", async (event) => {
    if (!event.data.type?.startsWith("abc:")) {
      return;
    }

    const { type, data } = event.data;

    if (type === "abc:set-auth-ticket") {
      const ticket = data.ticket as string;

      await AuthService.authenticateWithAuthTicket(ticket);
      await authStore.loadUser();
      await showLoadingWhile([router.push({ name: "dictionary" })]);
    }
  });
});
</script>

<template>
  <FocusedMessage>
    <template #message>{{ t("iframe.waiting-for-authentication.message") }}</template>
  </FocusedMessage>
</template>
